<template>
  <el-dialog
    title="问题详情"
    :visible.sync="dialogVisible"
    width="1375px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
    top="10vh"
  >
    <div class="question-detail">
      <div class="top">
        <div class="flex margin24">
          <div class="map-content">
            <MapCom v-if="formList.pointName" :pointInfo="formList"></MapCom>
          </div>
          <div class="right-top1">
            <div class="street">
              <span style="margin-right: 12px">
                {{ formList.taskDetail }}
              </span>
              <div v-if="formList.eventName" class="eventName">
                {{ formList.eventName }}
              </div>
              <div class="disposition">
                <img
                  v-if="formList.state == '待分拨'"
                  :src="require('@/assets/image/wcz.svg')"
                />
                <img
                  v-if="formList.state == '待认领'"
                  :src="require('@/assets/image/wcz.svg')"
                />
                <img
                  v-if="formList.state == '已归档'"
                  :src="require('@/assets/daping/img-ygd.png')"
                />
                <img
                  v-if="formList.state == '已办结'"
                  :src="require('@/assets/daping/img-ybj.png')"
                />
                <img
                  v-if="formList.state == '已处置'"
                  :src="require('@/assets/daping/img-ycz.png')"
                />
                <img
                  v-if="formList.state == '待处置'"
                  :src="require('@/assets/image/wcz.svg')"
                />
              </div>
            </div>
            <div class="info-box">
              <div class="info-box-item">
                <img src="@/assets/daping/ico-sbr.svg" alt="" />
                <span style="color: #adc2d3">上报人</span>
                <span>{{ formList.reportUserName }}</span>
              </div>
            </div>
            <div class="info-box">
              <div class="info-box-item">
                <img src="@/assets/daping/ico-lxfs.svg" alt="" />
                <span style="color: #adc2d3">联系方式</span>
                <span>{{ formList.reportUserTel }}</span>
              </div>
            </div>
            <div class="info-box">
              <div class="info-box-item">
                <img src="@/assets/daping/ico-sj.svg" alt="" />
                <span style="color: #adc2d3">上报日期</span>
                <span>{{ formList.reportTime }}</span>
              </div>
            </div>
            <div class="info-box">
              <div class="info-box-item">
                <img src="@/assets/daping/ico-address.svg" alt="" />
                <span style="color: #adc2d3">上报地点</span>
                <span>{{ formList.reportAddress }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="right-bottom">
          <div class="tabs">
            <div class="tabs-box">
              <div
                class="tabs-item"
                :class="{ active: curTab == item.value }"
                v-for="(item, index) in tabsOptions"
                :key="index"
                @click="tabsChange(item)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="form-content">
            <div v-if="curTab == 1" style="margin: 44px 24px 0">
              <div class="info-box">
                <div class="info-box-item">
                  <span style="color: #e4f2ff; margin-right: 16px">主办单位</span>
                  <span>{{ detailListForm.handleDeptName }}</span>
                </div>
              </div>
              <div class="info-box">
                <div class="info-box-item">
                  <span style="color: #e4f2ff; margin-right: 16px">指派人员</span>
                  <span>{{ detailListForm.handleUserName }}</span>
                </div>
              </div>
              <div class="info-box">
                <div class="info-box-item">
                  <span style="color: #e4f2ff; margin-right: 16px">现场照片</span>
                  <div class="keyPic">
                    <el-image
                      class="imgPic"
                      v-for="(itempic, index) in pointInfo.fileJsonZip"
                      :key="index"
                      :src="itempic"
                      :preview-src-list="pointInfo.fileJsonZip"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="curTab == 2">
              <div class="flex" v-if="detailList.length">
                <div class="fenbo">
                  <div
                    v-for="(item, index) in detailList"
                    @click="curClick(item, index)"
                    :key="idnex"
                    :class="['list', curTabIndex == index ? 'activeList' : '']"
                  >
                    <div class="flex">
                      <div class="handleDeptName">
                        {{ item.handleDeptName }}
                      </div>
                      <div :class="['assignType']">
                        {{ item.state }}
                      </div>
                    </div>
                    <div class="flex assignTime">
                      <div>{{ item.assignTime }} 分拨</div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 20px">
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">处置人</span>
                      <span>{{ detailListForm.handleUserName }}</span>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">处置时间</span>
                      <span>{{ detailListForm.handleTime }}</span>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">处置措施</span>
                      <span>{{ detailListForm.handleDetail }}</span>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="info-box-item">
                      <span style="color: #e4f2ff; margin-right: 16px">现场照片</span>
                      <div class="keyPic">
                        <el-image
                          class="imgPic"
                          v-for="(itempic, index) in detailListForm.handleFileJson"
                          :key="index"
                          :src="itempic.url"
                          :preview-src-list="detailListForm.handleFileJsonList"
                        >
                        </el-image>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="empty" v-else>
                <div style="text-align: center; margin-top: 50px">
                  <img src="@/assets/image/empty.png" alt="" />
                  <div style="font-size: 20px; color: #e4f2ff">暂无数据</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun()" :loading="exportLoading"
        >导 出</el-button
      >
    </span> -->
  </el-dialog>
</template>
<script>
import MapCom from "./mapCom.vue";
import { reportfullDetail } from "@/api/task.js";
export default {
  components: {
    MapCom,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    formList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tabsOptions: [
        {
          label: "上报详情",
          value: "1",
        },
        {
          label: "问题处置",
          value: "2",
        },
      ],
      detailHandleList: {},
      detailListForm: {},
      detailList: [],
      curTab: "1",
      curTabIndex: 0,
      pointInfo: {},
      processLi: process.env.VUE_APP_API_IMG_PATH,
    };
  },
  mounted() {
    this.qusetionDetail(this.formList);
  },
  watch: {
    formList: {
      handler(val) {
        this.qusetionDetail(val);
      },
      deep: true,
    },
  },
  methods: {
    async qusetionDetail(item) {
      this.pointInfo = item;
      if (!item.fileJsonZip && !item.fileJson) {
        this.pointInfo.fileJsonZip = [];
      } else {
        let jsonZip = item.fileJsonZip ? JSON.parse(item.fileJsonZip) : [];
        let jsonList = JSON.parse(item.fileJson);
        if (jsonZip.length == jsonList.length) {
          this.pointInfo.fileJsonZip = jsonZip.map((item) => {
            return this.processLi + item.filePath;
          });
        } else {
          this.pointInfo.fileJsonZip = jsonList.map((item) => {
            return item.url;
          });
        }
      }
      // 获取详情
      const res = await reportfullDetail({
        id: item.id,
      });
      if (res.data.code == 200) {
        this.detailHandleList = res.data.data;
        this.detailList = res.data.data.handleList;
        if (this.detailList.length > 0) {
          this.detailListForm = this.detailList && this.detailList[0];
          if (!this.detailListForm.handleFileJson) {
            this.detailListForm.handleFileJson = [];
            this.detailListForm.handleFileJsonList = [];
          } else {
            this.detailListForm.handleFileJson = JSON.parse(
              this.detailListForm.handleFileJson
            );
            this.detailListForm.handleFileJsonList = this.detailListForm.handleFileJson.map(
              (item) => item.url
            );
          }
        }
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    tabsChange(item) {
      this.curTab = item.value;
    },
    curClick(item, index) {
      this.detailListForm = item;
      this.curTabIndex = index;
      if (!this.detailListForm.handleFileJson) {
        this.detailListForm.handleFileJson = [];
      } else {
        this.detailListForm.handleFileJson = JSON.parse(this.detailList.handleFileJson);
      }
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  background: url("~@/assets/daping/detail-bg.png") no-repeat;
  background-size: 100% 100%;
  height: 937px;
  .el-dialog__header {
    padding: 16px 30px 16px 24px;
    border: none;
  }
  .el-dialog__title {
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 36px;
    color: #f3f8ff;
    line-height: 48px;
    text-align: left;
    font-style: normal;
    background: linear-gradient(180deg, #ddefff 0%, #5bacef 100%);
    color: transparent;
    /* 使用背景渐变填充文字 */
    -webkit-background-clip: text;
    background-clip: text;
    text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
    margin-left: 50px;
  }
  .el-dialog__headerbtn {
    .el-dialog__close {
      font-size: 40px;
      color: #adc2d3;
    }
  }
}

/deep/.el-dialog__body {
  max-height: 830px !important;
  padding: 10px 20px;
}

/deep/.el-input {
  width: auto !important;
}
.flex {
  display: flex;
}

.question-detail {
  height: calc(100% - 56px);
  border-radius: 8px 8px 0px 0px;

  .top {
    width: 100%;
    padding: 24px;
  }
  .map-content {
    width: 400px;
    height: 224px;
    margin: 0 24px 0 0;
  }
}

.right-top1 {
  margin-bottom: 8px;
  padding: 0px 0 10px 16px;
  position: relative;
  flex: 1;

  .street {
    display: flex;
    align-items: center;
    font-family: MiSans, MiSans;
    font-weight: 500;
    font-size: 28px;
    color: #e4f2ff;
    position: relative;
    flex-wrap: wrap;
    .eventName {
      background: rgba(0, 163, 255, 0.2);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 20px;
      color: #46abff;
      padding: 4px 12px;
    }
    .disposition {
      position: absolute;
      top: -10px;
      right: -10px;
      img {
        width: 120px;
        height: 120px;
      }
    }
  }

  .content {
    margin-top: 8px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #494c4f;
  }
  .info-box {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .info-box-item {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 20px;
      color: #e4f2ff;
      line-height: 28px;
      margin-right: 54px;

      img,
      span {
        margin-right: 16px;
      }

      img {
        height: 18px;
      }
    }

    .info-box-item:last-child {
      margin-right: 0;
    }
  }
}

.right-bottom {
  width: 100%;
  // max-height: 719px;
  // min-height: 561px;

  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 24px 8px;
    border-bottom: 1px solid rgba(70, 171, 255, 0.2);
    .tabs-box {
      display: flex;
      align-items: center;

      .tabs-item {
        padding-top: 10px;
        padding-bottom: 8px;
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 24px;
        color: #6e8095;
        margin-right: 48px;
        line-height: 32px;
        cursor: pointer;
        position: relative;
      }

      .tabs-item.active {
        font-family: MiSans, MiSans;
        font-weight: 500;
        color: #e4f2ff;
      }

      .tabs-item.active::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4px;
        width: 100%;
        background: #46abff;
        border-radius: 2px;
      }
    }

    .tupian-box {
      display: flex;
      align-items: center;

      width: 68px;

      .tupian-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 8px;
        height: 38px;
      }

      .tupian-item:first-child {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid #e0e0e0;

        img {
          height: 16px;
        }
      }

      .tupian-item:last-child {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #e0e0e0;

        img {
          height: 20px;
        }
      }
    }
  }

  .map-content {
    width: 100%;
    height: calc(100% - 56px);
    // min-height: 505px;
  }
}

.form-content {
  .info-box {
    margin-bottom: 24px;
    .info-box-item {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 20px;
      color: #adc2d3;
      line-height: 28px;
    }
  }
}

.keyPic {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  /deep/ .el-image {
    margin: 0 !important;
  }
  .imgPic {
    width: 240px;
    height: 240px;
    margin-right: 10px !important;
    border-radius: 6px;
    margin-bottom: 10px;
  }
}

.fenbo {
  width: 480px;
  margin: 20px 20px 0 24px;

  .list {
    width: 460px;
    height: 88px;
    background: rgba(0, 163, 255, 0.1);
    border-radius: 4px;
    padding: 12px 24px;
    position: relative;
    margin-bottom: 12px;

    .handleDeptName {
      font-family: MiSans, MiSans;

      line-height: 28px;
      font-weight: 400;
      font-size: 20px;
      color: #e4f2ff;
    }
    .assignType {
      position: absolute;
      top: 0;
      right: 0;
      background: rgba(99, 218, 161, 0.2);
      border-radius: 0px 6px 0px 6px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #63daa1;
      line-height: 24px;
      padding: 2px 4px;
    }
    .assignTime {
      margin-top: 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #adc2d3;
      line-height: 22px;
    }
    .disposition {
      position: absolute;
      top: 10px;
      right: 20px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }
  .activeList {
    border: 1px solid;
    border-image: linear-gradient(270deg, rgba(70, 171, 255, 0), rgba(70, 171, 255, 1)) 1
      1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/centerItem/components/reportDetail.vue